export default __webpack_public_path__ + "static/media/checked.6a2f4898.svg";